import React, { useEffect, useState } from 'react';
import { broadcastEnded, formatDayOrDate, getStartTime } from '../../../../utils/svtDateAndTime';
import { THEMES } from '../../../PlayBadge/PlayBadge';
import { StyledBadge } from './LiveBadge.styles';
import { BADGE_SIZE } from '../../ShowcaseCard';

const LiveBadge = ({ live, size }) => {
    const [isVod, setIsVod] = useState(false);

    useEffect(() => {
        if (live) {
            // If live ended but VOD is not yet encoded we still get the live object but should not show the badge.
            setIsVod(!live.liveNow && broadcastEnded(live.plannedEnd));
        }
    }, [live]);

    if (!live) {
        return null;
    }

    if (live.liveNow) {
        return (
            <StyledBadge
                theme={size === BADGE_SIZE.MEDIUM ? THEMES.LIVE_MEDIUM : THEMES.LIVE}
                text="Direkt"
                accessibilityText="Direktsänt just nu"
            />
        );
    }

    const startDay = formatDayOrDate(live.start);
    const startTime = getStartTime(live.start);

    return (
        <StyledBadge
            hidden={isVod}
            theme={size === BADGE_SIZE.MEDIUM ? THEMES.UPCOMING_MEDIUM : THEMES.UPCOMING}
            text={`${startDay} ${startTime}`}
            accessibilityText={`Kommande direktsändning ${startDay} ${startTime}`}
        />
    );
};

export default LiveBadge;
